var image_viewer_rtlignore_default = {
  "fontElementMap": "q9dlo",
  "imageContainer": "T5S2m",
  "expandButton": "_337Hj",
  "expandIcon": "HMS1W",
  "pointer": "Y22oa",
  "imageWrapper": "vFtsZ",
  "imageRatio": "SaL66",
  "image": "_6kvew",
  "imageOverlay": "gvFRN",
  "imagePreload": "MAEEm",
  "imageHighres": "-kT37",
  "onlyHighRes": "wrDsI",
  "image_loading": "_1mzjd"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
